<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">학습점수 관리</h5>
        <div
          class="sub_title"
          style="
            margin-bottom: 20px;
            color: #333;
            font-size: 13px;
            border: 1px solid #ccc;
            background: #f8f8f8;
            height: 30px;
            text-align: right;
            position: absolute;
            right: 20px;
            top: 10px;
            padding: 4px 10px 2px 10px;
          "
        >
          학습관리 → 학습점수 관리
        </div>
        <p
          style="
            font-size: 15px;
            margin-top: 10px;
            line-height: 25px;
            color: #004279;
            font-weight: 500;
          "
        >
          - 획득점수 기간조회는 Alpha 점수만 가능하며,
          <span style="font-weight: bold; color: red"
            >Fame과 Carat은 조회 되지 않습니다.</span
          ><br />
          <span style="font-weight: bold; color: red"
            >- 부당한 방법으로 획득된 점수는 관리자에 의해 차감될 수
            있습니다.</span
          >
        </p>

        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <td scope="row" style="text-align: center">{{ record.id }}</td>

              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="record.t2" :biz="record.t2" />
              </td>

              <td style="text-align: center">
                <Business v-if="record.t1" :biz="record.t1" />
              </td>
              <td style="text-align: center">
                <!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                {{ record.username }}
              </td>

              <td style="text-align: center">
                <Student :student="record" />
              </td>
              <td style="text-align: center">{{ record.level }}</td>
              <td style="text-align: center">
                <template v-if="record.fame == 'N/A'">사용할 수 없음</template
                ><template v-else>{{
                  parseInt(record.fame).toLocaleString()
                }}</template>
              </td>
              <td style="text-align: center">
                <template v-if="record.alpha == 'N/A'">사용할 수 없음</template
                ><template v-else>{{
                  parseInt(record.alpha).toLocaleString()
                }}</template>
              </td>
              <td style="text-align: center">
                <template v-if="record.carat == 'N/A'">사용할 수 없음</template
                ><template v-else>{{
                  parseInt(record.carat).toLocaleString()
                }}</template>
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Business from "../components/Business";
import Student from "../components/detail_pages/Student";
import QueryGrid from "../components/QueryGrid";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Business,
    Student,
    QueryGrid,
  },
  mounted() {
    if (this.$root.guiPerm == "ROOT") {
      this.config.search_fields.push({
        id: "search_del",
        name: "삭제여부",
        type: "switch",
        filter_type: {
          false: "정상",
          true: "삭제",
        },
      });
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.config.columns.splice(1, 1);
    }

    this.$refs.qg.search();
  },
  methods: {
    getDiff(value) {
      var moment = require("moment"); // moment 모듈불러오기

      const diff = moment().diff(value, "hours");
      const days = Math.floor(diff / 24);
      const hours = diff % 24;

      return -days;
    },
  },
  data() {
    return {
      config: {
        name: "학생 리스트_점수",
        req_endpoint: "/students",
        default_limit: 20,
        extras_addon: () => {
          return "&embed_score=true&status_filter=[%22ACTIVE%22]";
        },
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "date_filter",
            name: "획득점수",
            type: "date",
            filter_type: {
              point_time: "ALPHA",
            },
          },
          {
            id: "level_filter",
            name: "레벨",
            type: "switch",
            filter_type: {
              GK: "GK",
              GK_1: "GK_1",
              GR1: "GR1",
              GR2: "GR2",
              GR3: "GR3",
              GR4: "GR4",
              GR5: "GR5",
              GR6: "GR6",
              GR7: "GR7",
              GR8: "GR8",
              GR9: "GR9",
              GR10: "GR10",
              GR11: "GR11",
              GR12: "GR12",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder:
              "아이디/이름/회원번호/튜터명/학원/클래스/담당교사/레벨",
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "회원번호",
            excel_print: (v) => {
              return v.id;
            },
          },

          {
            id: "biz",
            sortable: true,
            name: "학원",
            excel_print: (v) => {
              return v.t2.name;
            },
          },
          {
            id: "class",
            sortable: true,
            name: "클래스/캠퍼스",
            excel_print: (v) => {
              return v.t1.name;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "level",
            sortable: true,
            name: "레벨",
            excel_print: (v) => {
              return v.level || "";
            },
          },
          {
            id: "fame",
            sortable: true,
            name: "Fame",
            excel_print: (v) => {
              return v.fame || "";
            },
          },
          {
            id: "alpha",
            sortable: true,
            name: "Alpha",
            excel_print: (v) => {
              return v.alpha || "";
            },
          },
          {
            id: "carat",
            sortable: true,
            name: "Carat",
            excel_print: (v) => {
              return v.carat || "";
            },
          },
        ],
        disable_init_search: true,
      },
    };
  },
};
</script>
